module.exports = __webpack_public_path__ + "static/img/1.0a9fe5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/1.png
// module id = iGYk
// module chunks = 1 3